export default __webpack_public_path__ + "static/media/cloth_1.3970d5d0.jpg";